import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const Tab6ResumeDiagnostic = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));

  return (
    <div className="om-fields">

      <div className="om-field-group">
        <label>Résumé et diagnostic syndromique <ConfidenceLabel confidence={gc("resume")} /></label>
        <textarea rows={8}
          placeholder="Résumé clinique complet : âge, poids, motif, antécédents, HDM, conclusion physique..."
          value={form.resume ?? ""}
          onChange={(e) => onChange("resume", e.target.value)}
          style={{ borderColor: gc("resume").color || undefined }} />
      </div>

      <div className="om-section-label">Hypothèses diagnostiques</div>

      <div className="om-field-group">
        <label>Hypothèse 1 <ConfidenceLabel confidence={gc("hypothese_1")} /></label>
        <input type="text" placeholder="Ex : Lymphome malin" value={form.hypothese_1 ?? ""}
          onChange={(e) => onChange("hypothese_1", e.target.value)}
          style={{ borderColor: gc("hypothese_1").color || undefined }} />
      </div>

      <div className="om-field-group">
        <label>Hypothèse 2 <ConfidenceLabel confidence={gc("hypothese_2")} /></label>
        <input type="text" placeholder="2e hypothèse diagnostique" value={form.hypothese_2 ?? ""}
          onChange={(e) => onChange("hypothese_2", e.target.value)}
          style={{ borderColor: gc("hypothese_2").color || undefined }} />
      </div>

      <div className="om-field-group">
        <label>Hypothèse 3 <ConfidenceLabel confidence={gc("hypothese_3")} /></label>
        <input type="text" placeholder="3e hypothèse diagnostique" value={form.hypothese_3 ?? ""}
          onChange={(e) => onChange("hypothese_3", e.target.value)}
          style={{ borderColor: gc("hypothese_3").color || undefined }} />
      </div>

      <div className="om-divider" />

      <div className="om-field-group">
        <label>Notes complémentaires / Actes réalisés <ConfidenceLabel confidence={gc("notes_complementaires")} /></label>
        <textarea rows={6}
          placeholder="Ponction d'ascite, cytoponction, résultats biologiques, marqueurs tumoraux..."
          value={form.notes_complementaires ?? ""}
          onChange={(e) => onChange("notes_complementaires", e.target.value)}
          style={{ borderColor: gc("notes_complementaires").color || undefined }} />
      </div>
    </div>
  );
};

export default Tab6ResumeDiagnostic;